var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Uh-Oh!")]),_c('h3',[_vm._v(" It looks like you're experiencing some network issues, please click the back button and try again. ")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Or go back to the home page")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }